import store from '@/store/store'

export const createEmotionSeries = (detections, totalCaptures, captureHeight) => {
  const emotionSeries = []
  detections.sort((a, b) => a.faceRectangle.top - b.faceRectangle.top)
  for (let i = 0; i < totalCaptures; i++) {
    const imageTop = i * captureHeight
    const imageBottom = (i + 1) * captureHeight
    const detection = detections.find(detection => detection.faceRectangle.top >= imageTop && detection.faceRectangle.top < imageBottom)
    const emotionSeriesItem = store.state.gameplay.emotions.map(emotion => detection ? detection.faceAttributes.emotion[emotion.name] : 0)
    emotionSeries.push(emotionSeriesItem)
  }
  return emotionSeries
}

export const createScoreSeries = (emotionSeries1, emotionSeries2) => {
  if (emotionSeries1.length !== emotionSeries2.length) console.error('Emotion series lengths do not match')
  const totalCaptures = emotionSeries1.length
  const userScoreSeries = emotionSeries1.map((emotionSeriesItem1, i) => {
    if (emotionSeriesItem1.every(val => val === emotionSeriesItem1[0])) return 0
    const emotionSeriesItem2 = emotionSeries2[i]
    return 100 / totalCaptures - emotionSeriesItem1.reduce((acc, emotionScore, i) => {
      return acc + Math.abs(emotionScore - emotionSeriesItem2[i]) / 2 / totalCaptures * 100
    }, 0)
  })
  return userScoreSeries
}
